import React from 'react';

export const Mobile = () => (
	<h1>Mobile</h1>
);


// WEBPACK FOOTER //
// ./src/containers/Mobile/Mobile.js